import { render, staticRenderFns } from "./Permission.vue?vue&type=template&id=31f95c78&scoped=true&"
import script from "./Permission.vue?vue&type=script&lang=js&"
export * from "./Permission.vue?vue&type=script&lang=js&"
import style0 from "./Permission.vue?vue&type=style&index=0&id=31f95c78&lang=scss&scoped=true&"
import style1 from "./Permission.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31f95c78",
  null
  
)

export default component.exports